import { render, staticRenderFns } from "./SaleTable.vue?vue&type=template&id=2d14c72b&scoped=true&"
import script from "./SaleTable.vue?vue&type=script&lang=ts&"
export * from "./SaleTable.vue?vue&type=script&lang=ts&"
import style0 from "./SaleTable.vue?vue&type=style&index=0&id=2d14c72b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d14c72b",
  null
  
)

export default component.exports